import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { MenuItem } from "@mui/material";
import Button from '@mui/material/Button';
import { blue } from '@material-ui/core/colors/';
import ComputerIcon from '@mui/icons-material/Computer';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { addHardwareModel } from '../../services/service';
import { FormDialog } from '../../components/FormDialog';
import { APITextField } from '../../components/APITextField';
import { APISelectField } from '../../components/APISelectField';

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[700],
  '&:hover': {
    backgroundColor: blue[900],
  },
}));

const validationSchema = Yup.object({
  manufacturer: Yup
    .string('Enter the hardware company name')
    .required('Field is required'),
  model: Yup
    .string('Enter hardware model')
    .required('model is required'),
  cpu_arch: Yup.string()
    .oneOf(['x86-64', 'armhf', 'armv7'])
    .required('Necessário escolher a quantidade!'),
})

export default function BtnAddHardwareModel({ onHardwareModelCreated, sx }) {
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      manufacturer: "",
      model: "",
      cpu_model: "",
      cpu_arch: "",
      cpu_frequency_ghz: "",
      cpu_cores: "",
      ram_size_gb: "",
      disk_size_gb: "",
    },
    validationSchema: validationSchema,
  })

  const onSubmit = () => {
    console.log("Submitting")
    setLoading(true)
    addHardwareModel(
      formik.values.manufacturer,
      formik.values.model,
      formik.values.cpu_model,
      formik.values.cpu_arch,
      formik.values.cpu_frequency_ghz,
      formik.values.cpu_cores,
      formik.values.ram_size_gb,
      formik.values.disk_size_gb
    )
      .then((response) => {
        console.log(response)
        if (response['status'] === 201) {
          setOpen(false);
          onHardwareModelCreated(response.data);
          formik.resetForm();
        } else {
          console.log(response.data)
        }
      }).catch((err) => {
        setErrors(err.response.data);
      })
      .finally((resp) => {
        setLoading(false)
      })
  }

  const handleClickOpen = () => {
    setErrors(undefined);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={sx}>
      <ColorButton
        startIcon={<ComputerIcon></ComputerIcon>}
        onClick={handleClickOpen}
        size="large"
        variant="contained"
        sx={{ padding: 2, width: "100%" }}
      >
        Adicionar Modelo de hardware
      </ColorButton>
      <FormDialog
        title={"Adicionar Hardware"}
        open={open}
        onDismiss={handleClose}
        onSubmit={onSubmit}
        formWidth={500}
        loading={loading}
      >
        <APITextField
          id="model"
          label="Modelo"
          disabled={loading}
          value={formik.values.model}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.model}
        />
        <APITextField
          id="manufacturer"
          label="Fabricante"
          disabled={loading}
          defaultValue={formik.values.manufacturer}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.manufacturer}
        />
        <APITextField
          id="cpu_model"
          label="Modelo de CPU"
          disabled={loading}
          value={formik.values.cpu_model}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.cpu_model}
        />
        <APISelectField
          name="cpu_arch"
          value={formik.values.cpu_arch}
          onChange={formik.handleChange}
          variant={"standard"}
          label={"Selecione a Arquitetura"}
          errors={errors?.cpu_arch}
        >
          <MenuItem value='x86-64'>x86-64</MenuItem>
          <MenuItem value="armhf">armhf</MenuItem>
          <MenuItem value="armv7">armv7</MenuItem>
        </APISelectField>
        <APITextField id="cpu_frequency_ghz"
          label="Frequência da CPU (GHz)"
          disabled={loading}
          value={formik.values.cpu_frequency_ghz}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.cpu_frequency_ghz}
        />
        <APITextField id="cpu_cores"
          label="Numero de núcleos  da CPU "
          disabled={loading}
          value={formik.values.cpu_cores}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.cpu_cores}
        />
        <APITextField id="ram_size_gb"
          label="Quantidade de RAM (GB)"
          disabled={loading}
          value={formik.values.ram_size_gb}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.ram_size_gb}
        />
        <APITextField id="disk_size_gb"
          label="Tamanho de Armazenamento (GB)"
          disabled={loading}
          value={formik.values.disk_size_gb}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.disk_size_gb}
        />
      </FormDialog>
    </Box>
  );
}